<template>
	<div v-if="hypermarketDetails">
		<slot name="header" />
		<div v-if="pending">
			<div v-for="index in 5" :key="index" class="skeleton-gradient h-5 w-full mb-2 rounded-lg" />
			<div class="skeleton-gradient h-8 w-36 mt-3 rounded-xl" />
		</div>
		<template v-else>
			<div v-if="hypermarketDetails.openingHourEntities" class="flex gap-x-2 items-start py-2">
				<NuxtIcon
					name="clock"
					class="text-sm sm:text-base text-icon-primary max-sm:mt-0.5"
					filled
				/>
				<OpeningHoursTable
					:entities="hypermarketDetails.openingHourEntities"
					class="grow text-sm"
					linked-content
					linked-content-hypermarket
					@update:click="handleClick"
				/>
			</div>
			<div v-if="capacity !== null" class="flex gap-x-2 items-center py-2 text-body-s">
				<NuxtIcon
					name="users"
					class="text-sm sm:text-base text-icon-primary"
					filled
				/>
				<span>Aktuální obsazenost prodejny</span>
				<span class="ml-auto">{{ n(capacity, {style: 'percent'}) }}</span>
			</div>
		</template>

		<AbsoluteInternalLink
			v-if="selectedBranchLabelFresh"
			:to="branchSpecificPath({name: ''})"
			class="btn btn-secondary xl:btn-secondary btn-xs justify-center text-center max-xs:grow mt-1.5 xl:shadow-sm"
			:aria-label="`Zobrazit více o pobočce ${selectedHypermarket}`"
			@click="handleClick('Více o pobočce | Otevírací doba')"
		>
			<NuxtIcon
				name="custom/arrow-right"
				class="text-lg transition duration-300"
				filled
				aria-hidden="true"
			/>
			Více o pobočce
		</AbsoluteInternalLink>
	</div>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '../../../stores/storyblokHypermarkets';
	import {useHypermarketCapacityStore} from '../../../stores/hypermarketCapacity';

	type Emits = {
		(e: 'update:click', text: string): void
	};

	const emit = defineEmits<Emits>();

	const {n} = useI18n();
	const branchSpecificPath = useBranchSpecificPath();

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarket, selectedHypermarketInstance} = storeToRefs(hypermarketsStore);
	const selectedBranchLabelFresh = computed(() => selectedHypermarketInstance.value?.branchType === 'fresh');

	const hypermarketCapacityStore = useHypermarketCapacityStore();
	await hypermarketCapacityStore.fetchCapacity();
	const {capacity} = storeToRefs(hypermarketCapacityStore);

	const {data: hypermarketDetails, loading: pending} = useHypermarketDetails(selectedHypermarket);

	function handleClick(text: string) {
		emit('update:click', text);
	}

	watch(selectedHypermarketInstance, () => {
		hypermarketCapacityStore.fetchCapacity();
	});
</script>
